exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Shared-Loading__relative {\n  position: relative;\n}\n\n.Shared-Loading__center {\n  position: absolute;\n  top: 49%;\n  left: 49%;\n}\n", ""]);

// exports
exports.locals = {
	"relative": "Shared-Loading__relative",
	"center": "Shared-Loading__center"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./src/reactjs/shared/components/Loading/Loading.css
// module id = ECxK
// module chunks = 2